import { useTranslation } from 'react-i18next'
import { H3, Text, Caption, Button } from '@/components/atoms'
import {
  CoverageClaimIcon,
  CoverageGrowthTrendIcon,
  CoverageGroupLifeIcon,
} from '@/components/atoms/icons/coverage-feature'
import { FeatureItem } from '@/components/molecules'

const FEATURES = [
  { key: 'visitVet', Icon: CoverageGroupLifeIcon },
  { key: 'trackProgress', Icon: CoverageGrowthTrendIcon },
  { key: 'getPaidBack', Icon: CoverageClaimIcon },
] as const

export function PetStepFivePage({
  onBack,
  onContinue,
}: {
  onBack: () => void
  onContinue: () => void
}) {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:flex md:flex-row md:justify-between md:pt-6 md:pb-0">
        <div className="flex flex-col justify-between gap-4 md:max-w-98">
          <div className="flex flex-col gap-4 md:max-w-90 md:gap-6">
            <H3 className="">{t('onboarding.pet.step5.title')}</H3>
            <Text className="text-neutral-600">
              {t('onboarding.pet.step5.body')}
            </Text>
            <Caption>
              <span className="text-indigo-base">*</span>
              {t('onboarding.pet.step5.footnote')}
            </Caption>
          </div>
          <div className="hidden gap-3 md:mb-2.5 md:flex">
            <Button
              className="h-12"
              variant="secondary"
              onClick={onBack}
              data-testid="step-five-back"
            >
              {t('onboarding.pet.back')}
            </Button>
            <Button
              className="h-12"
              onClick={onContinue}
              data-testid="step-five-continue"
            >
              {t('onboarding.pet.continue')}
            </Button>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-4 md:mt-0 md:max-w-98 md:gap-8">
          {FEATURES.map(({ key, Icon }) => (
            <FeatureItem
              key={key}
              icon={<Icon />}
              title={t(`onboarding.pet.step5.features.${key}.title`)}
              description={t(
                `onboarding.pet.step5.features.${key}.description`,
              )}
            />
          ))}
        </div>
      </div>

      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          className="h-12 w-full"
          variant="secondary"
          onClick={onBack}
          data-testid="step-five-back"
        >
          {t('onboarding.pet.back')}
        </Button>
        <Button
          className="h-12 w-full"
          onClick={onContinue}
          data-testid="step-five-continue"
        >
          {t('onboarding.pet.continue')}
        </Button>
      </div>
    </div>
  )
}
